
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'
import store from '../store'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const CreateCallProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean
  }
})

@Component
export default class CreateCallModal extends CreateCallProps {
  // @Prop(Boolean) close: boolean | false
  data () {
    return {
      isLoading: false,
      // participants: [],
      datetime: null,
      formDataValid: false,
      users: [],
      selectedUserId: null,
      loggedUserId: null
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['selectedUserId', 'datetime'], function () {
      var valid = this.$refs.form.checkValidity()
      valid = valid && this.datetime && this.datetime > new Date()
      // this.formDataValid = valid && this.participants.length > 0
      this.formDataValid = valid && this.selectedUserId != null
    })
    this.getCurrUserId()
    this.getUsers()
  }

  getCurrUserId () {
    this.loggedUserId = store.getters.getLoggedUserId
  }

  /* updateUserId (value, idx) {
    this.participants[idx] = Number.parseInt(value)
  }

  removeUserId (idx) {
    this.participants.splice(idx, 1)
  } */

  async scheduleCall () {
    this.isLoading = true
    try {
      var data = {
        // userIds: this.participants,
        userIds: [this.selectedUserId],
        scheduleTo: this.datetime
      }
      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/scheduleCall`, data)
      if (resp.error || resp.statusCode) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: `Could not schedule call. Reason: ${resp.error ? resp.error : resp.message}`,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Call Scheduled Sucessfully.',
          onConfirm: async () => {
            // window.location.href = '/home/schedulecall'
            this.participants = []
            this.selectedUserId = null
            this.datetime = null
            this.$emit('created')
          },
          canCancel: false
        })
      }
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
    }
  }

  async getUsers () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUsers`))
      this.users = resp.filter(e => e.id !== this.loggedUserId)
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get Users.',
        canCancel: false
      })
    }
  }
}
